import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Attachment } from '@ee/common/models';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DocumentService } from '@ee/common/services';
import { DOCX_FILE_MIME_TYPES, PDF_FILE_EXTENSION } from '@ee/common/constants';

@Component({
  selector: 'ee-pdf-preview-dialog',
  template: `
    @if (!hideTitle) {
      <h2 mat-dialog-title>{{ title ?? 'Preview' }}</h2>
    }
    <div mat-dialog-content class="pdf-wrapper">
      @if (!pdfSrc) {
        <div class="flex flex-row flex-1 justify-center items-center">
          <ee-loading message="Loading..."></ee-loading>
        </div>
      } @else {
        <pdf-viewer class="viewer" [src]="pdfSrc" [show-all]="true" [autoresize]="true" [original-size]="false"
                    [show-borders]="true"></pdf-viewer>
      }
    </div>
    <div mat-dialog-actions class="ee-modal-actions">
      <button mat-button [mat-dialog-close]="null" type="button"
        data-tracking-event="pdf-preview-dialog-close">CLOSE</button>
      <button mat-flat-button color="accent" (click)="saveDocumentAsPdf()" type="button"
        data-tracking-event="pdf-preview-dialog-download">DOWNLOAD</button>
    </div>
  `,
  styles: [`
    ee-pdf-preview-dialog {
      .pdf-wrapper {
        flex: 1;
        min-height: 70vh;
        max-height: 100%;
        overflow: auto;
        display: flex;
        flex-direction: column;

        .viewer {
          flex: 1;
          min-height: 70vh;
          height: 100%;
          width: 100%;
          display: block;

          .ng2-pdf-viewer-container {
            overflow: auto;
            width: 100%;
            height: 100%;
          }
        }
      }

    }
  `],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class PdfPreviewDialogComponent implements OnInit, OnDestroy {
  subs: Subscription[] = [];
  docxFileMimeType = DOCX_FILE_MIME_TYPES;
  title = 'Preview';
  attachment: Attachment;
  hideTitle = false;
  pdfSrc: string | Uint8Array;

  constructor(private documentService: DocumentService, public cdr: ChangeDetectorRef, @Inject(MAT_DIALOG_DATA) public data: {
    attachment: Attachment,
    downloadUrl: string | Uint8Array,
    hideTitle: boolean
  }) {
    this.attachment = data.attachment;
    this.pdfSrc = data.downloadUrl;
    this.hideTitle = !!data.hideTitle;
  }

  ngOnInit(): void {
    this.title = this.attachment.original_filename ?? this.attachment.description ?? this.title;
  }

  saveDocumentAsPdf() {
    const filename = this.documentService.generateFilenameFromPath(this.attachment, PDF_FILE_EXTENSION);
    if (typeof this.pdfSrc === 'string') {
      this.documentService.saveDocumentFromUrl(filename, this.pdfSrc);
    } else {
      const blob = new Blob([this.pdfSrc.buffer as ArrayBuffer], { type: 'application/pdf' });
      this.documentService.saveDocument(filename, blob);
    }
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }
}